import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ListenRejectedReasons, Modals } from '@/constants';
import { selectPlan, uiActions } from '@/store';
import { PurchaseType } from '@/types';

export const useListenToPlanChanges = () => {
  const { data: plan } = useSelector(selectPlan);
  const dispatch = useDispatch();
  const prevUsageRemaining = useRef<number | null>(null);

  useEffect(() => {
    // When free trial plan first reaches 0 credits, show a message
    const shouldShowFreeTrialEndedModal =
      plan?.purchaseType === PurchaseType.FREE_TRIAL &&
      prevUsageRemaining.current! > 0 &&
      plan?.usageRemaining === 0;

    if (shouldShowFreeTrialEndedModal) {
      dispatch(uiActions.closeActiveModal());

      dispatch(
        uiActions.setActiveModal({
          name: Modals.LISTEN_REJECTED,
          params: {
            listenRejectedReason: ListenRejectedReasons.FREE_TRIAL_ENDED,
          },
        }),
      );
    }

    prevUsageRemaining.current = plan?.usageRemaining ?? null;
  }, [plan, dispatch]);
};
